export const US_Product_List: any = [
    {
        productId: '15299543269449',
        variantId: '54335221137481',
        // Buy Now only (no Amazon)
        link_more: 'https://us.ecoflow.com/products/river-3-max-plus-river-3-plus-extra-battery-600',
    },
    {
        productId: '7290968473673',
        variantId: '41636514136137',
        link_more: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.com/dp/B0DCCB657J?maas=maas_adg_C0A3AA9BAE8973E8449D0C6CE223F878_afap_abs&ref_=aa_maas&tag=maas',
    },
    {
        productId: '7290968473673',
        variantId: '41636515807305',
        link_more: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.com/dp/B0DPW7T85G?maas=maas_adg_5E285AC98099A0C21497F230ACED498B_afap_abs&ref_=aa_maas&tag=maas',
    },
];

export const US_Product_Options = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        amazonTimes: {
            startTime: '2024/12/10 16:00:00 GMT+8',
            endTime: '2024/12/15 16:00:00 GMT+8',
        },
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        amazonTimes: {
            startTime: '2024/12/10 16:00:00 GMT+8',
            endTime: '2024/12/15 16:00:00 GMT+8',
        },
        discountPrice: 0,
        originalPrice: 0,
    },
];

export const CA_Product_List: any = [
    {
        productId: '8335910928538',
        variantId: '45166394409114',
        // Buy Now only (no Amazon)
        link_more: 'https://ca.ecoflow.com/products/river-3-portable-power-station',
    },
    {
        productId: '8335918792858',
        variantId: '45166421999770',
        link_more: 'https://ca.ecoflow.com/products/river-3-plus-portable-power-station',
        link_view: 'https://www.amazon.ca/dp/B0DFXX4D1D?maas=maas_adg_2DABF6F381CC91F0D654B7EA87A98D25_afap_abs&ref_=aa_maas&tag=maas',
    },
];

export const CA_Product_Options = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        hasTopRight: true,
        discountPrice: 0,
        originalPrice: 0,
        needBenefit: true,
        benefitTimes: {
            startTime: '2025/01/09 16:00:00 GMT+8',
            endTime: '2025/01/19 16:00:00 GMT+8',
        },
        amazonTimes: {
            startTime: '2025/01/09 16:00:00 GMT+8',
            endTime: '2025/01/13 16:00:00 GMT+8',
        },
    },
    {
        isDialog: true,
        label: 'Coming soon',
    },
];

export const BR_Product_List: any = [
    {
        productId: '9574047645992',
        variantId: '49859304915240',
        link_more: 'https://br.ecoflow.com/products/river-3-portable-power-station',
    },
    {
        link_more: 'https://br.ecoflow.com/products/river-3-plus-portable-power-station',
    },
    {
        link_more: 'https://br.ecoflow.com/products/river-3-max-portable-power-station',
    },
];

export const BR_Product_Options = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        disable: true,
        isAmazon: true,
        // label: 'Em breve',
    },
    {
        disable: true,
        isAmazon: true,
        // label: 'Em breve',
    },
];

export const MX_Product_List: any = [
    {
        productId: '7704626298959',
        variantId: '42614299983951',
        link_more: 'https://mx.ecoflow.com/products/river-3-portable-power-station',
    },
    {
        productId: '7704665358415',
        variantId: '42614576808015',
        link_more: 'https://mx.ecoflow.com/products/river-3-plus-portable-power-station',
    },
    {
        productId: '7726897168463',
        variantId: '42732210257999',
        link_more: 'https://mx.ecoflow.com/products/river-3-max-river-3-plus-extra-battery-300',
    },
];

export const MX_Product_Options = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        // disable: true,
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
];

export const PH_Product_List: any = [
    {
        productId: '10083967598902',
        variantId: '51563840733494',
        link_more: 'https://ph.ecoflow.com/products/river-3-ups-portable-power-station',
    },
    {
        productId: '10084078715190',
        variantId: '51563978719542',
        link_more: 'https://ph.ecoflow.com/products/river-3-plus-portable-power-station',
    },
    {
        productId: '10125377012022',
        variantId: '51677738074422',
        link_more: 'https://ph.ecoflow.com/products/ecoflow-river-3-max-plus-portable-power-station',
    },
];

export const PH_Product_Options: any = [
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
    {
        isAmazon: true,
        discountPrice: 0,
        originalPrice: 0,
    },
];
